module.exports = __webpack_public_path__ + "img/ds_tape.95fc0ef3.png";